import { css } from 'styled-components';
import token from 'styled-token';
import { StyledListboxOptionLabel } from '../../components/ListboxOptionLabel/ListboxOptionLabel.styles';
import { StyledListboxOptionMedia } from '../../components/ListboxOptionMedia/ListboxOptionMedia.styles';
import { checkboxStateMixin } from '../checkboxStateMixin';
import { disabledMixin } from '../disabledMixin';
import { iconOffsetMixin } from '../iconOffsetMixin';
import { radioStateMixin } from '../radioStateMixin';
import { typographyMixin } from '../typographyMixin';
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance,
    icon = props.icon;
  if (!appearance && !icon) {
    return '';
  }
  return token({
    fontType: 'ListboxOption.fontType',
    mediaSize: 'ListboxOption.mediaSize',
    iconSize: 'ListboxOption.iconSize',
    iconColor: 'ListboxOption.iconColor',
    horizontalSpacing: 'ListboxOption.horizontalSpacing',
    verticalSpacing: 'ListboxOption.verticalSpacing'
  }, function (_ref) {
    var fontType = _ref.fontType,
      mediaSize = _ref.mediaSize,
      iconSize = _ref.iconSize,
      iconColor = _ref.iconColor,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing;
    var styles = [css(["position:relative;padding-left:", "px;", "{position:absolute;height:", "px;width:", "px;left:", "px;top:", "px;display:flex;justify-content:center;align-items:center;}"], mediaSize + horizontalSpacing * 1.5, StyledListboxOptionMedia, mediaSize, mediaSize, horizontalSpacing, verticalSpacing)];
    if (icon) {
      styles.push(css(["", "{", " color:", ";}"], StyledListboxOptionMedia, iconOffsetMixin(Object.assign({}, props, {
        fontType: fontType,
        iconSize: iconSize
      })), iconColor));
      return styles;
    }
    styles.push(css(["", ":before{content:'';", "}&:hover:not([aria-disabled='true']) ", ":before{", "}&[aria-selected='true'] ", ":before{", "}&[aria-disabled='true'] ", ":before{cursor:default;}"], StyledListboxOptionMedia, radioStateMixin()(props), StyledListboxOptionMedia, radioStateMixin('hover')(props), StyledListboxOptionMedia, radioStateMixin('checked')(props), StyledListboxOptionMedia));
    if (appearance === 'checkbox') {
      styles.push(css(["", ":before{", "}&[aria-selected='true'] ", ":before{", "}"], StyledListboxOptionMedia, checkboxStateMixin()(props), StyledListboxOptionMedia, checkboxStateMixin('checked')(props)));
    }
    return styles;
  })(props);
};
export var ListboxOptionMixin = function ListboxOptionMixin(props) {
  return token({
    backgroundColor: 'ListBoxOption.backgroundColor',
    backgroundColorHover: 'ListboxOption.backgroundColorHover',
    backgroundColorActive: 'ListboxOption.backgroundColorActive',
    backgroundColorPressed: 'ListboxOption.backgroundColorPressed',
    fontType: 'ListboxOption.fontType',
    horizontalSpacing: 'ListboxOption.horizontalSpacing',
    verticalSpacing: 'ListboxOption.verticalSpacing',
    labelFontWeight: 'ListboxOption.Label.fontWeight'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      backgroundColorHover = _ref2.backgroundColorHover,
      backgroundColorActive = _ref2.backgroundColorActive,
      backgroundColorPressed = _ref2.backgroundColorPressed,
      fontType = _ref2.fontType,
      horizontalSpacing = _ref2.horizontalSpacing,
      verticalSpacing = _ref2.verticalSpacing,
      _ref2$labelFontWeight = _ref2.labelFontWeight,
      labelFontWeight = _ref2$labelFontWeight === void 0 ? 'bold' : _ref2$labelFontWeight;
    return css(["cursor:pointer;padding:", "px ", "px;background-color:", ";transition:background-color 200ms ease;&:not([aria-disabled='true'])[data-active='true']{background-color:", ";}&:not([aria-disabled='true']):not([data-active='true']):hover{background-color:", ";}&:not([aria-disabled='true']):active{background-color:", ";}&[aria-selected='true'] ", "{font-weight:", ";}&[aria-disabled='true']{", "}", " ", ""], verticalSpacing, horizontalSpacing, backgroundColor, backgroundColorActive, backgroundColorHover, backgroundColorPressed, StyledListboxOptionLabel, labelFontWeight, disabledMixin(Object.assign({}, props, {
      disabled: true
    })), typographyMixin(Object.assign({
      fontType: fontType
    }, props)), appearanceCSS(props));
  })(props);
};